import { createMuiTheme } from '@material-ui/core/styles'

/* Deployment Stuff
 ************************************************* */
const development = {
  apiServer: 'https://tyler-dot-cookn-cloud.appspot.com',
  // apiServer: 'https://app.cookn-cloud.com',
  baseUrl: ''
}

const staging = {
  apiServer: '//app.cookn-cloud.com',
  // apiServer: '//tyler-dot-cookn-cloud.appspot.com',
  baseUrl: '/cookn-staging'
}

const production = {
  apiServer: '//app.cookn-cloud.com',
  baseUrl: '/cookn'
}

const config =
  process.env.REACT_APP_STAGE === 'production'
    ? production
    : process.env.REACT_APP_STAGE === 'staging'
      ? staging
      : development

/* Theme Stuff
 ************************************************* */
const theme = createMuiTheme({
  palette: {
    primary: {
      // light:
      main: '#51a4bd',
      // dark:
      contrastText: '#fff !important'
    },
    secondary: {
      //main: '#565E67',
      main: '#ef3b3a',
      contrastText: '#fff !important'
    },
    error: {
      main: '#e94236'
    }
  }
})

const loginStyles = theme => ({
  card: {
    maxWidth: '400px',
    margin: '0 auto 20px auto'
  }
})

export default {
  // Add common config values here
  //MAX_ATTACHMENT_SIZE: 5000000,
  theme,
  loginStyles,
  ...config
}



// WEBPACK FOOTER //
// ./src/config.js